import { tokenEmailPost, tokenPost } from "../../services/gailServices";
import {STOP_LOADING,START_LOADING} from  "./actionTypes";



export const postTokenAction = (formData) => async (dispatch,getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'GAIL' });
      
      const token = getState().auth.token || sessionStorage.getItem("token");;
      const response = await tokenPost(formData,token);
    
      dispatch({ type: STOP_LOADING, service: 'GAIL' });
      dispatch({ type: 'GAIL_SUCCESS', payload:response });
   
    } catch (error) {
      dispatch({ type: STOP_LOADING, service: 'GAIL' });
      dispatch({ type: 'GAIL_FAILURE', payload: error || 'Gail failed. Please try again.' });
    }
  };

  export const postEmailTokenAction = (formData) => async (dispatch,getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'VERIFY_EMAIL' });
      
      const response = await tokenEmailPost(formData);
     
      dispatch({ type: STOP_LOADING, service: 'VERIFY_EMAIL' });
      dispatch({ type: 'VERIFY_EMAIL_SUCCESS', payload:response });
    
    } catch (error) {
      dispatch({ type: STOP_LOADING, service: 'VERIFY_EMAIL' });
      const errorData = error ? error : {
        errors: [{
          errorMessage: 'Email verification failed. Please try again.',
          target: null
        }]
      };
      dispatch({ type: 'VERIFY_EMAIL_FAILURE', payload: errorData || 'Verify email failed. Please try again.' });
      
    }
  };
